import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiDataService } from 'src/app/api/services/api-data.service';
import { SERVER_API_URL_NEW } from 'src/app/common/types/app.constants';
import { Archive } from 'src/app/common/types/archive.interface';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.scss']
})
export class ArchiveComponent implements OnInit {

  archive: Archive[] = [];

  @Output() onCloseSideNav = new EventEmitter<void>();

  constructor(private service: ApiDataService, private router: Router) { }

  ngOnInit(): void {
  }

  onGetArchive(): void {
    const archiveResultsDetailed = 'competition-results-archived';
    this.service.getAll<Archive>(archiveResultsDetailed).subscribe((results: Archive[]): void => {
      this.archive = results;
    });
  }

  /**
   * function for stage results loading of desired stage in competition
   * @param stageId for evaluation of specific stage
   */
  onSelectStageResult(competitionId: number, stageId: number): void {
    this.onCloseSideNav.emit();
    this.router.navigate(['/competition', competitionId, 'stage', stageId, 'results']);
  }

  /**
   * function for round results loading of desired round in competition
   * @param roundId for evaluation of specific round
   */
  onSelectRoundResult(competitionId: number, roundId: number): void {
    this.onCloseSideNav.emit();
    this.router.navigate(['/competition', competitionId, 'round', roundId, 'results']);
  }

  /**
   * function for navigation to competition results
   */
  onSelectCompetitionResult(competitionId: number): void {
    this.onCloseSideNav.emit();
    this.router.navigate(['/competition', competitionId, 'results']);
  }

  /**
   * function for navigating to selected driving report
   * @param competitionId for evaluation of desired competition
   * @param stageId for evaluation of desired stage
   * @param crewId for evaluation of desired crew
   * @param drivingReportId for evaluation of desired driving report
   */
  onSelectDrivingReport(competitionId: number, stageId: number, crewId: number, drivingReportId: number): void {
    this.onCloseSideNav.emit();
    this.router.navigate(['/competition', competitionId, 'stage', stageId, 'crew', crewId, 'driving-report', drivingReportId]);
  }
}
